var firebase_front = null;
var front_messaging = null;
var firebaseConfig_front = null;
try {

    // Your web app's Firebase configuration
   firebaseConfig_front = {
    apiKey: "AIzaSyDb4B_kHwxIvR0iINPp6CGoqIFkqLVHvHw",
    authDomain: "qawafil.firebaseapp.com",
    databaseURL: "https://qawafil.firebaseio.com",
    projectId: "qawafil",
    storageBucket: "qawafil.appspot.com",
    messagingSenderId: "499304031786",
    appId: "1:499304031786:web:6d5d0c42d57c22fe0b0553",
    measurementId: "G-Z1NJBTVDVJ",
      vapidKey: "BESUxjUKrX57Ni0Qjpl_DikiOdJJkPMRfPs59y1ooJfsGJkpGlnTe4JWKQytpBYGENbwagnVZScUtbZEJlmtpKw"
  };

   // Initialize Firebase
   firebase_front = firebase.initializeApp(firebaseConfig_front, 'front');
   front_messaging = firebase_front.messaging();
   // front_messaging.usePublicVapidKey('BESUxjUKrX57Ni0Qjpl_DikiOdJJkPMRfPs59y1ooJfsGJkpGlnTe4JWKQytpBYGENbwagnVZScUtbZEJlmtpKw');


} catch (error) {
consoleLog('fcm_init', error)
}
